import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export const LegalModal = ({ open, onClose, title, children }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        data-testid="legal-modal"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
        className="fixed inset-0 z-[90] bg-ink/80 backdrop-blur-md flex items-center justify-center p-4 sm:p-8"
      >
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 30, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.65, 0, 0.35, 1] }}
          onClick={(e) => e.stopPropagation()}
          className="relative w-full max-w-2xl max-h-[80vh] overflow-y-auto bg-ink-2 border border-white/10 p-8 sm:p-12"
        >
          <button
            data-testid="legal-modal-close"
            onClick={onClose}
            aria-label="Cerrar"
            className="absolute top-5 right-5 text-[var(--muted)] hover:text-glacier transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
          <h3 className="font-display font-light text-3xl sm:text-4xl mb-6">{title}</h3>
          <div className="font-body font-light text-sm text-[var(--muted)] leading-relaxed space-y-4">
            {children}
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
